interface SharingProfile {
  fulltextSharing?: boolean;
  dropboxSync?: boolean;
  searchDatabase?: boolean;
  showUnpaywall?: boolean;
  showPreflight?: boolean;
  showCopyleaks?: boolean;
  bxRecommender?: boolean;
}

interface AltLinkResolver {
  name?: string;
  url?: string;
}

export class SettingsModel {

  wayflessURL?: string;
  constructor(
    public defaultCitationStyles?: any[],
    public linkResolverName?: string,
    public linkResolverUrl?: string,
    public sharingProfile?: SharingProfile,
    public sponsorText?: string,
    public sponsorURL?: string,
    public linkResolver?: AltLinkResolver,
    public additionalProfileInformationName?: string,
    public additionalProfileInformationAnswers?: string[],
    public profileCreationMessage?: string
  ) {}
}

export class CopyleaksCredits {
  userCreditFree: number;
  userCreditLimit: number;
  refWorksCreditsLeft: number;
}
